<script>
  export default {
    name: "AtomStarRating",
    props: {
      value: { type: Number, default: 0 },
      max: { type: Number, default: 5 },
      disabled: { type: Boolean, default: false },
    },
    methods: {
      setRating(r) {
        if (!this.disabled) this.$emit("input", r);
      },
    },
  };
</script>

<template>
  <div class="star-rating">
    <span v-for="n in max" :key="n" class="star-rating__star" :class="{ 'star-rating__star--filled': n <= value }" @click="setRating(n)">★</span>
  </div>
</template>

<style lang="scss" scoped>
  .star-rating {
    display: inline-flex;
    cursor: pointer;
    font-size: 32px;
    color: #c3c3c3;

    &__star--filled {
      color: #bd0909;
    }

    &__star {
      margin-right: 2px;
    }
  }
</style>
